import footer from './footer.component';

export default angular
  .module('fizyweb.paycell.footer', [])
  .component('fizyPaycellFooter', footer).name;



// WEBPACK FOOTER //
// src/app/components/footer/footer.module.ts